import Main from './components/Main.js'
import Header from './components/structure/Header.js';
import Footer from './components/structure/Footer.js';

function App() {
  return (
    <div className="App">
        <Header />
        <Main />
        <Footer />
    </div>
  );
}

export default App;
